import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  makeStyles,
} from '@material-ui/core';
import Skeleton from 'components/Skeleton';
import useVerifyNewsList from 'customHooks/useVerifyNewsList';
import Pagination from '@material-ui/lab/Pagination';
import noImage from 'images/noImage.jpg';
import {
  acceptNewsVerify,
  rejectNewsRequest,
} from 'features/VerifyNews/verifyNewsSlice';
import { imgBaseURL } from '../../apis/Admin';
import { showLoader } from 'utils';

const useStyles = makeStyles({
  root: {
    flexGrow: 1,
  },
  table: {
    minWidth: 1000,
  },
  container: {
    margin: '1rem',
  },
  filter: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
    padding: '1rem',
  },
  pagination: {
    marginLeft: 'auto',
    margincenter: 'auto',
    marginBottom: '60px',
  },
  center: {
    textAlign: 'center',
  },
  end: {
    textAlign: 'end',
  },
  imgWidth: {
    width: '50px',
  },
});

export default function VerifyNews() {
  const dispatch = useDispatch();
  const history = useHistory();
  const classes = useStyles();
  const [callStart, setCallStart] = useState(0);
  const [page, setPage] = React.useState(1);
  const VerifyNewsList = useVerifyNewsList(callStart, 10);
  const totalUsers = useSelector(state => state.verifyNews.totalList);
  const loader = useSelector(state => state.verifyNews.loading);
  const imgUrl = imgBaseURL;
  const totalPages_pre = totalUsers / 10;
  const totalUserPages =
    totalUsers % 10 === 0 ? totalPages_pre : Math.trunc(totalPages_pre) + 1;
  console.log(VerifyNewsList, 'VerifyNewsList');

  useEffect(() => {
    setCallStart((page - 1) * 10);
  }, [page]);

  const handlePageChange = (value) => {
    setPage(value);
  };

  const acceptNews = id => {
    const data = {
      news: [id],
    };
    dispatch(acceptNewsVerify(data));
    history.push('/news');
  };
  const rejectNews = id => {
    const data = {
      news: [id],
    };
    dispatch(rejectNewsRequest(data));
    history.push('/news');
  };

  return (
    <Skeleton>
      <div className={classes.root}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <TableContainer className={classes.container} component={Paper}>
              <Table className={classes.table} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell align="center">Image</TableCell>
                    <TableCell align="center">User</TableCell>
                    <TableCell align="center">Title</TableCell>
                    <TableCell align="center">Description</TableCell>
                    <TableCell align="center">Verify</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {VerifyNewsList.map(news => (
                    <TableRow key={news._id} className={classes.center}>
                      <TableCell align="center">
                        <img
                          src={news.image ? `${imgUrl}/${news.image}` : noImage}
                          alt="news_image"
                          className={classes.imgWidth}
                        />
                      </TableCell>
                      <TableCell align="center">{news.user.userName}</TableCell>
                      <TableCell align="center">{news.title}</TableCell>
                      <TableCell align="center">{news.description}</TableCell>
                      <TableCell align="center">
                        <Grid container>
                          <Grid xs={6} className={classes.end}>
                            <Button
                              variant="contained"
                              color="primary"
                              onClick={() => acceptNews(news._id)}
                            >
                              Accept
                            </Button>
                          </Grid>
                          <Grid xs={6} className={classes.start}>
                            <Button
                              variant="contained"
                              color="secondary"
                              onClick={() => rejectNews(news._id)}
                            >
                              Reject
                            </Button>
                          </Grid>
                        </Grid>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
              <div style={{ textAlign: 'center' }}>
                {VerifyNewsList.length === 0 && 'No Data'}
              </div>
            </TableContainer>
            <div className={classes.pagination}>
              <Pagination
                color="primary"
                count={totalUserPages ? totalUserPages : 0}
                page={page}
                onChange={handlePageChange}
              />
            </div>
          </Grid>
        </Grid>
      </div>
      {showLoader(loader)}
    </Skeleton>
  );
}
